<template>
  <div class="absolute top-1/3 left-0 w-full" v-if="current_orders.length == 0">
    <div class="text-center w-full">
      <null-icon></null-icon>
    </div>
    <div class="pt-5 font-extrabold text-center text-xl">There are no active orders</div>
    <div class="pt-2 text-center text-lg leading-none px-6">You don’t have any undelivered orders at this point.</div>
    <div class="pt-24 mx-6 text-xs" @click="arrange">
      <input-button>ARRANGE NEW DELIVERY</input-button>
    </div>
    <div class="fixed left-0 top-0 w-full bg-dark-transparent h-screen" v-if="loader">
      <div class="absolute top-2/4 w-full">
        <loading :width="'w-10'" :height="'h-10'"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import NullIcon from '@/components/icons/NullIcon.vue'
import InputButton from '@/components/inputs/InputButton.vue'
import Swal from 'sweetalert2'
import uniqid from 'uniqid'
import { mapState } from 'vuex'
import Loading from '../icons/Loading.vue'

export default {
  components: {
    NullIcon,
    InputButton,
    Loading
  },
  data() {
    return {
      loader: false
    }
  },
  computed: {
    ...mapState('arrange', ['unfinished']),
    ...mapState('current_orders', ['current_orders'])
  },
  methods: {
    arrange() {
      this.loader = true
      if (this.unfinished == '') {
        var uniqueId = uniqid()
        this.$store.dispatch('arrange/startArrangement', uniqueId)
      } else {
        this.loader = false
        Swal.fire({
          text: "You have'nt finished placing your last order",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Continue with last order`,
          denyButtonText: `Delete and start new order`
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$router.push({
              name: 'Arrange',
              params: { id: this.unfinished }
            })
          } else if (result.isDenied) {
            this.$store.dispatch('arrange/deleteArrangement', this.unfinished).then(() => {
              var uniqueId = uniqid()
              this.$store.dispatch('arrange/startArrangement', uniqueId)
            })
          }
        })
      }
    }
  },
  mounted() {
    this.$store.dispatch('arrange/hasUnfinishedOrder')
  }
}
</script>
